<template>
  <div class="About" onclick="_hmt.push(['_trackEvent', 'website', 'click', '点击'])">
    <meta name="keywords" content="以诺教育，高端教育，海外游学；斯坦福；以色列">
    <meta
      name="description"
      content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"
    >
    <title>关于以诺-以诺教育</title>
    <headTop></headTop>
    <div class="AboutEnoch">
      <div class="zhContents">
        <div class="zhFloating">
          <div class="zhList1">
            <span class="zhYinuo">关于以诺</span>
          </div>
          <div class="zhList">
            <span class="zhYinuo zhShu">源起</span>
          </div>
          <div class="zhList">
            <span class="zhYinuo">校长寄语</span>
          </div>
          <div class="zhList">
            <span class="zhYinuo">愿景与使命</span>
          </div>
          <div class="zhList">
            <span class="zhYinuo">我们的服务</span>
          </div>
        </div>
        <div class="zhOrigin">
          <!--<span>O</span><span>R</span><span>I</span><span>G</span><span>I</span><span>N</span><span>S</span>-->
          <div class="zhNR">
            <i>源</i>
            <i>起</i>
          </div>
          <div class="zhDown"></div>
        </div>
        <div class="zhOriginCon">
          <div class="zhOriginConList">
            <div class="zhOM"></div>
            <img src="../../assets/originicon.png" alt>
            <div class="zhP">创业初心</div>
            <div class="zhOriginLeft">
              <div class="zhLeftM">
                <img src="../../assets/originicon.png" alt>
                <p class="zhBT">创业初心</p>
                <p class="zhJG"></p>
                <p
                  class="zhBTCon"
                >以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。</p>
              </div>
            </div>
          </div>
          <div class="zhOriginConList">
            <div class="zhOM"></div>
            <img src="../../assets/originpp.png" alt>
            <div class="zhP">品牌寓意</div>
            <div class="zhOriginLeft zhOriginLeft2">
              <div class="zhLeftM">
                <img src="../../assets/originpp.png" alt>
                <p class="zhBT">品牌寓意</p>
                <p class="zhJG"></p>
                <p
                  class="zhBTCon"
                >“以诺”的英文“Enoch”源于希腊语Eunoia，意为Beautiful Thinking（美妙的思维）。在《圣经》中，Enoch是一个得神喜悦和恩典的人，代表三大含义：开端、奉献、教师。他发明了许多实用的学问，直到现在还被人们所使用，例如书写、数学、天文学等</p>
              </div>
            </div>
          </div>
          <div class="zhOriginConList">
            <div class="zhOM"></div>
            <img src="../../assets/originfz.png" alt>
            <div class="zhP">发展历史</div>
            <div class="zhOriginLeft zhOriginLeft3">
              <div class="zhLeftM">
                <img src="../../assets/originfz.png" alt>
                <p class="zhBT">发展历史</p>
                <p class="zhJG"></p>
                <p
                  class="zhBTCon"
                >经过3年，以诺教育完成了100多次海内外高端游学课程，如名闻遐尔的《以色列创智之旅》和引领国内高净值财富管理课程的《财富学堂》。4000多名中国高净值人士在以诺教育的带领下，在全球完成了一次次学习之旅。诚如诺亚财富创始人、董事局主席兼CEO汪静波女士所言：“在任何市场环境下，学习，是对自己最好的投资。”</p>
              </div>
            </div>
          </div>
        </div>
        <div class="zhOrigin">
          <!--<span>P</span><span>R</span><span>E</span><span>S</span><span>I</span><span>D</span><span>E</span><span>N</span><span>T</span><span>'</span><span>S</span><span>M</span><span>E</span><span>S</span><span>S</span><span>A</span><span>G</span><span>E</span>-->
          <div class="zhNR">
            <i>校</i>
            <i>长</i>
            <i>寄</i>
            <i>语</i>
          </div>
          <div class="zhDown" style="width:154px;"></div>
        </div>
        <div class="zhPresident">
          <div class="zhPreLeft">
            <p
              class="zhPreWord"
            >世界上有很多人，他们衣食无忧，但内心依然觉得欠缺，他们反复思索着生命的激情和意义。也有一些人，突破思想的牢笼，身体力行，对自己的人生永无止境、无惧无畏地探寻。</p>
            <p
              class="zhPreWord"
            >古希腊先贤苏格拉底有句名言：“认识你自己！”认识自己就是认识我们内在的心灵。在当今充满复杂、冲突以及快速创新的世界，我们每个人都要思考：如何学习成长？如何度过有品质的一生？</p>
            <p
              class="zhPreWord"
            >“格物、致知、诚意、正心、修身、齐家、治国、平天下”这短短17个字，代表了中国传统文化中个人修行之路的精髓。也说明，学习不仅需要头脑的思考，更需要身体的亲历和灵魂的沉浸。</p>
            <p
              class="zhPreWord"
            >以诺教育遵从古希腊哲学中的共善和普世精神，提供心灵扩展和启明之博雅教育。通过科学、系统、深入地洞察客户需求，嫁接全球最高端的教育资源，精准地匹配教育产品与客户需求，成为高端学习生活的导航者。</p>
            <p class="zhPreWord">以诺，在路上！</p>
          </div>
          <div class="zhPreRight">
            <img src="../../assets/Principal.png" alt>
          </div>
          <div class="zhPreBottom">以诺教育创始人、董事长</div>
          <img src="../../assets/autograph.png" alt class="zhServiceImg">
        </div>
        <div class="zhOrigin">
          <!--<span>C</span><span>O</span><span>R</span><span>P</span><span>O</span><span>R</span><span>A</span><span>T</span><span>E</span><span>C</span><span>U</span><span>L</span><span>T</span><span>U</span><span>R</span><span>E</span>-->
          <div class="zhNR">
            <i>愿</i>
            <i>景</i>
            <i>与</i>
            <i>使</i>
            <i>命</i>
          </div>
          <div class="zhDown" style="width:196px;"></div>
        </div>
        <div class="zhMission">
          <div class="zhMissionLeft">
            <img src="../../assets/zhxiu.png" alt class="img">
            <div class="zhMissionCon">
              <p class="zhMissionYY">我们的愿景</p>
              <p class="zhHG"></p>
              <p class="zhHGCon">知识丰盈人生财富，学习创造价值与感动</p>
            </div>
          </div>
          <div class="zhMissionLeft">
            <img src="../../assets/president1.png" alt class="img">
            <div class="zhMissionCon">
              <p class="zhMissionYY">我们的使命</p>
              <p class="zhHG"></p>
              <p class="zhHGCon">创建中国知名的教育文化品牌，以终生学习的场域，为个人、家族、企业提供有形、无形财富知识服务。</p>
            </div>
          </div>
        </div>
        <div class="zhOrigin">
          <!--<span>O</span><span>U</span><span>R</span><span>S</span><span>E</span><span>R</span><span>V</span><span>I</span><span>C</span><span>E</span><span>S</span>-->
          <div class="zhNR">
            <i>我</i>
            <i>们</i>
            <i>的</i>
            <i>服</i>
            <i>务</i>
          </div>
          <div class="zhDown" style="width:196px;"></div>
        </div>
        <div class="zhService">
          <div class="image">
            <img src="../../assets/service.png" alt>
          </div>
          <p
            class="zhSerCon"
          >围绕高净值客户和企业家个人、家庭和企业全方位学习和增长智慧的需求，以诺教育目前提供涵盖投资理财、企业管理、亲子教育、心灵成长、自然人文五大主题课程。此外，以诺教育还为特定团体或机构定制主题班，帮助企业或团体提升凝聚力、协作力，开拓视野。</p>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import headTop from "../headTop/headTop";
import Bottom from "../Bottom/Bottom";
export default {
  name: "AboutEnoch",
  components: { headTop, Bottom },
  data() {
    return {};
  },
  //滚轮楼层添加
  created() {
    var that = this;
    //滚轮事件
    window.addEventListener("scroll", function() {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop > 0 && scrollTop <= 400) {
        $(".zhList")
          .children()
          .removeClass("zhShu");
        $(".zhList")
          .eq(0)
          .children()
          .addClass("zhShu");
      } else if (scrollTop > 400 && scrollTop <= 800) {
        $(".zhList")
          .children()
          .removeClass("zhShu");
        $(".zhList")
          .eq(1)
          .children()
          .addClass("zhShu");
      } else if (scrollTop > 800 && scrollTop <= 1140) {
        $(".zhList")
          .children()
          .removeClass("zhShu");
        $(".zhList")
          .eq(2)
          .children()
          .addClass("zhShu");
      } else if (scrollTop > 1140) {
        $(".zhList")
          .children()
          .removeClass("zhShu");
        $(".zhList")
          .eq(3)
          .children()
          .addClass("zhShu");
      } else if (scrollTop > 1340) {
        $(".zhList")
          .children()
          .removeClass("zhShu");
        $(".zhList")
          .eq(5)
          .children()
          .addClass("zhShu");
      }
    });
  },
  mounted() {
    $(".zhOriginConList").mouseenter(function() {
      $(this)
        .children(".zhOriginLeft")
        .css({ left: 0 });
    });
    $(".zhOriginConList").mouseleave(function() {
      $(this)
        .children(".zhOriginLeft")
        .css({ left: "-310px" });
    });
    //点击跳转
    $(".zhList").click(function() {
      $(".zhList")
        .children()
        .removeClass("zhShu");
      $(this)
        .children()
        .addClass("zhShu");
      if ($(this).index() == 1) {
        $(document).scrollTop(0);
      } else if ($(this).index() == 2) {
        $(document).scrollTop(567);
      } else if ($(this).index() == 3) {
        $(document).scrollTop(1007);
      } else if ($(this).index() == 4) {
        $(document).scrollTop(1426);
      } else if ($(this).index() == 5) {
        $(document).scrollTop(1690);
      }
    });
  }
};
</script>

<style scoped>
.AboutEnoch {
  background: #f4f5f9;
  padding-bottom: 255px;
  padding-top: 1px;
}
.zhFloating {
  width: 160px;
  height: 275px;
  background: #ffffff;
  position: fixed;
  margin: 0 0 0 -190px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
.zhList {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #4f4f4f;
  cursor: pointer;
}
.zhList:hover {
  background: #01b784;
  color: #ffffff;
}
.zhList1 {
  width: 100%;
  font-size: 14px;
  color: #4f4f4f;
  font-weight: bold;
  padding: 30px 0 10px;
}
.zhYinuo {
  padding-left: 30px;
}
.zhShu {
  border-left: 2px solid #01b784;
}
.zhContents {
  width: 1150px;
  margin: 0 auto;
  padding-left: 190px;
}
.zhOrigin {
  width: 100%;
  height: 60px;
  margin-top: 30px;
  text-align: center;
  font-size: 12px;
  color: #909090;
  box-sizing: border-box;
  line-height: 30px;
  position: relative;
}
.zhOrigin > span {
  margin: 0 13px;
}
.zhNR {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 26px;
  color: #4f4f4f;
  font-weight: bold;
}
.zhNR i {
  font-style: normal;
  margin: 0 8px;
}
.zhDown {
  width: 68px;
  height: 4px;
  position: absolute;
  top: 35px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: #01b784;
}
.zhOriginCon {
  width: 100%;
  height: 400px;
}
.zhOriginConList {
  width: 310px;
  height: 100%;
  float: left;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background: url(../../assets/originBG1.png) no-repeat 0 0;
}
.zhOriginConList:nth-child(2) {
  background: url(../../assets/originPPBG.png) no-repeat 0 0;
}
.zhOriginConList:nth-child(3) {
  background: url(../../assets/originfzBG.png) no-repeat 0 0;
}
.zhOM {
  width: 100%;
  height: 100%;
  background: #00336e;
  opacity: 0.5;
}
.zhOriginConList > img {
  width: 114px;
  display: block;
  position: absolute;
  top: 142px;
  left: 98px;
}
.zhOriginConList .zhP {
  position: absolute;
  top: 266px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  font-size: 24px;
  color: #ffffff;
}
.zhOriginLeft {
  z-index: 999;
  opacity: 1;
  width: 310px;
  height: 100%;
  position: absolute;
  top: 0;
  left: -310px;
  transition: all 0.3s ease;
  background: url(../../assets/originBG1.png) no-repeat 0 0;
}
.zhOriginLeft2 {
  background: url(../../assets/originPPBG.png) no-repeat 0 0;
}
.zhOriginLeft3 {
  background: url(../../assets/originfzBG.png) no-repeat 0 0;
}
.zhLeftM {
  width: 100%;
  height: 100%;
  background: #01b784;
  opacity: 0.8;
  box-sizing: border-box;
  padding: 56px 33px 0 22px;
  overflow: hidden;
}
.zhLeftM > img {
  display: block;
  position: absolute;
  bottom: -20px;
  left: -20px;
  width: 114px;
  z-index: 999;
}
.zhBT {
  font-size: 22px;
  color: #ffffff;
}
.zhJG {
  width: 52px;
  height: 2px;
  margin: 8px 0 17px 0;
  background: #ffc962;
}
.zhBTCon {
  font-size: 14px;
  color: #ffffff;
}
.zhPresident {
  width: 100%;
  height: 348px;
  background: #ffffff;
  box-sizing: border-box;
  padding: 40px;
  position: relative;
}
.zhPreBottom {
  position: absolute;
  bottom: 55px;
  right: 30px;
  font-size: 16px;
  color: #4f4f4f;
}
.zhServiceImg {
  display: block;
  width: 86px;
  position: absolute;
  bottom: 10px;
  right: 76px;
}
.zhPreLeft {
  width: 709px;
  float: left;
}
.zhPreRight {
  width: 155px;
  float: right;
  margin-left: 15px;
  height: 220px;
}
.zhPreRight > img {
  width: 100%;
  height: 100%;
  display: block;
}
.zhPreWord {
  font-size: 14px;
  color: #909090;
  width: 100%;
  padding-bottom: 20px;
}
.zhMission {
  width: 100%;
  height: 336px;
}
.zhMissionLeft {
  width: 450px;
  height: 100%;
  background: #ffffff;
  float: left;
}
.zhMissionLeft:nth-child(2) {
  margin-left: 30px;
}
.zhMissionLeft:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.img {
  width: 100%;
  height: 170px;
  display: block;
}
.zhMissionCon {
  box-sizing: border-box;
  padding: 20px;
}
.zhMissionYY {
  letter-spacing: 8px;
  font-size: 20px;
  font-weight: bold;
  color: #4f4f4f;
}
.zhHG {
  width: 46px;
  height: 2px;
  background: #ffc962;
  margin: 10px 0 0 86px;
}
.zhHGCon {
  width: 350px;
  font-size: 16px;
  color: #909090;
  padding-top: 22px;
}
.zhService {
  width: 100%;
  height: 204px;
  background: #ffffff;
}
.image {
  width: 260px;
  height: 100%;
  float: left;
}
.image > img {
  display: block;
  width: 100%;
  height: 100%;
}
.zhSerCon {
  width: 670px;
  box-sizing: border-box;
  padding: 40px 20px 0 20px;
  float: left;
  font-size: 16px;
  color: #909090;
  line-height: 36px;
}
.zhApplpgize {
  overflow: hidden;
}
.zhApplpgize .zhPreLeft {
  width: 100%;
  background: #ffffff;
  padding: 40px;
}
</style>



// WEBPACK FOOTER //
// AboutEnoch.vue?34f200f4